export const REPORT_ID = 'world-overview-major-crops';
export const REPORT_APE_ID = 'world-overview-major-crops-ape';